import { useEffect, useState } from "react";

export default function useDebounce(value, delay = 1000) {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const timout = setTimeout(() => {
      setDebounced(value);
    }, delay);
    return () => clearTimeout(timout);
  }, [value, delay]);
  return debounced;
}
